import React, {ReactNode} from 'react';
import styled from 'styled-components';

import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {UserThemeConsumer} from '../../../../../libs/shared/ui/src/theme/userThemeConsumer';

/*
 * Style.
 */

const StyledButtonTextDiv = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 8px;
  align-items: center;
  padding-left: 3px;
`;

const StyledButtonDiv = styled.div`
  width: fit-content;
`;

/*
 * Attachment button.
 */

interface RenderAttachmentButtonArgs {
  buttonText: ReactNode;
  shouldShowChevron: boolean;
  onClick?: () => void;
  isDisabled?: boolean;
  isDropdownOpen?: boolean;
}

// Attachment button template that can be modified for use as a dropdown button,
// a simple button to upload from computer, or from an integration.
export function renderAttachmentButton(args: RenderAttachmentButtonArgs) {
  const {buttonText, shouldShowChevron, onClick, isDisabled, isDropdownOpen} = args;
  return (
    <UserThemeConsumer>
      {(theme) => (
        <StyledButtonDiv>
          <Button
            variant={ButtonVariantsEnum.SECONDARY}
            size={VisualSizesEnum.MEDIUM}
            onClick={onClick}
            isDisabled={isDisabled}
            hasHover={isDropdownOpen}
          >
            <StyledButtonTextDiv>
              {buttonText}
              {shouldShowChevron && <Icon name="chevronDownSmall" color={theme.greys.shade60} />}
            </StyledButtonTextDiv>
          </Button>
        </StyledButtonDiv>
      )}
    </UserThemeConsumer>
  );
}
